
import { api } from '../services/redux-beesConfig';
import isString from 'lodash/isString';
import isNil from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import store from '../Store';
import { getActiveLanguage } from 'react-localize-redux';

class AuthService {
  static isLogged() {
  let token = AuthService.getToken();
    return (token !== '');
  }
  static getToken() {
    let token = localStorage.getItem('token');
    if(isNil(token) || isUndefined(token) || token === '') {
      return '';
    }
    return token;
  }
  static login(values) {
    if (values.rememberMe){

    }
    return api.login({ locale: `${getActiveLanguage(store.getState().locale).code}`}, { login: values.login, password: values.password, rememberMe: values.rememberMe ? 1 : 0 })
      .then((res) => {
        if (isString(res.body.data.token)) {
          this.setToken(res.body.data.token);
          localStorage.setItem('userID', res.body.data.id);
          return true;
        }
        return false;
      }).catch((error) => {
        if (error.body){
          throw error.body.errors[0].detail;
        }
        throw error;
      });
  }
  static setToken(token) {
    localStorage.setItem('token', token);
    return true;
  }
  static logOut(dispatch) {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('userID');
      dispatch({
        type: 'SET_AUTH_USER_INFO',
        id:'',
        token:'',
      })
    } catch (e) {
      console.log(e);
    }
    try {
      // const cookies = new Cookies();
      // cookies.remove('token');
    } catch (e) {

    }
    return true;
  }
  static logOut() {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('userID');
      store.dispatch({
        type: 'SET_AUTH_USER_INFO',
        id:'',
        token:'',
      })
    } catch (e) {
      console.log(e);
    }
    return true;
  }
  static setAuthUserProfile(dispatch) {
    let userID = AuthService.getUserID();
    const token = AuthService.getToken();
    dispatch({
      type: 'SET_AUTH_USER_INFO',
      id:userID,
      token:token,
    })
     dispatch(api.getUserProfile({ locale: `${getActiveLanguage(store.getState().locale).code}`,id:userID }))
     .then(res => {
       const data = res.body.data;
       dispatch({
         type: 'SET_USER_INFO',
         user: data.user,
         paymentMethod: data.paymentMethod,
       })
     })
  }
  static getUserID() {
    let UserID = localStorage.getItem('userID');
    if(isNil(UserID) || isUndefined(UserID) || UserID === '') {
      return '';
    }
    return UserID;
  }
};

export default AuthService;



// WEBPACK FOOTER //
// ./src/services/AuthService.js